import styled from 'styled-components';
import PlayerMatchup from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup';
import Table from '@mlb/react-patterns/v4/components/Table/table';
import { PlayerNameWrapper, PlayerInfoWrapper, PlayerMatchupWrapper } from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import { PlayerDuelWrapper } from '../PlayerDuel/GameContextPlayerDuel.style';
import { ImageWrapper } from '@mlb/react-patterns/v4/components/Image/image.style';
import { GAME_CONTEXT_BREAKPOINTS } from '../themes/breakpoints';
import { MatchupStateWrapper } from '../PlayerDuel/PlayerDuel.style';

const { DESKTOP, XL_MIN } = GAME_CONTEXT_BREAKPOINTS;
export const ProbablePitchersDisplay = styled.div`
    justify-content: space-between;
    display:flex;
    flex-direction: column;
    gap: 16px;
    @media (min-width: ${XL_MIN}) {
        gap: 24px;
    }
    ${PlayerDuelWrapper} {
        ${ImageWrapper} {
            width: 48px;
            @media (min-width: ${DESKTOP}) {
                width: 78px;
            }
        }
        ${PlayerMatchupWrapper} {
            justify-content: space-around;
            margin: 0;
            padding: 0;
            > div:last-child > div:first-child > div {
                border-bottom: none;
                color: var(--gameday-game-context-primary-text-color);
            }
        }
        ${MatchupStateWrapper} {
            display: none;
        }
    }
`;

export const PitcherContainer = styled.div`
    display: flex;
    height: 44px;
`;

export const Pitcher = styled(PlayerMatchup)`
    min-width: 211px;
    height: 44px;
    span {
        margin-left: 0px;
        font-size: 14px;
        line-height: 100%;
    }
    div {
        font-size: 16px;
        line-height: 100%;
        &:empty {
            display:none;
        }
    }
    ${PlayerNameWrapper} {
        color: var(--gameday-game-context-primary-text-color);
    }
    ${PlayerInfoWrapper} {
        color: var(--gameday-game-context-secondary-text-color);
    }
`;

export const PitcherStatsTable = styled(Table)`
    thead {
            border-bottom: none;
            margin-bottom: 8px;
        th {
            border-bottom: none;
            margin-bottom: 8px;
            padding: 0;
            font-weight: 700;
            font-size: 14px;
            color: var(--gameday-game-context-primary-text-color);

        }
    }
    tbody {
        td {
            padding: 0;
            font-size: 16px;
            color: var(--gameday-game-context-primary-text-color);
        }
    }
`;

export const ProbablePitchersTitle = styled.div`
    font-weight: 700;
    font-size: 16px;
    line-height: 16px;
    color: var(--gameday-game-context-primary-text-color);
    @media (min-width: ${DESKTOP}) {
        font-size: 19px;
        line-height: 19px;
    }
`;
